import React, { useState, useEffect } from 'react';
import { getStats } from '../services/api';
import {
  Container,
  Header,
  Cards,
  Box,
  SpaceBetween,
  StatusIndicator
} from '@cloudscape-design/components';

const Stats = () => {
  const [stats, setStats] = useState({ customers: 0, accounts: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setLoading(true);
        const data = await getStats();
        setStats(data);
        setError(null);
      } catch (err) {
        setError('Failed to load statistics. Please try again later.');
        console.error('Error fetching stats:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  return (
    <Container>
      <SpaceBetween size="l">
        <Header
          variant="h1"
          description="Overview of system statistics"
        >
          System Statistics
        </Header>

        {loading ? (
          <StatusIndicator type="loading">Loading statistics...</StatusIndicator>
        ) : error ? (
          <StatusIndicator type="error">{error}</StatusIndicator>
        ) : (
          <Cards
            cardDefinition={{
              header: item => item.title,
              sections: [
                {
                  id: "value",
                  header: "Value",
                  content: item => (
                    <Box variant="awsui-key-label" fontSize="display-l" fontWeight="bold">
                      {item.value}
                    </Box>
                  )
                }
              ]
            }}
            cardsPerRow={[
              { cards: 1 },
              { minWidth: 500, cards: 2 }
            ]}
            items={[
              {
                title: "Total Customers",
                value: stats.customers
              },
              {
                title: "Total Accounts",
                value: stats.accounts
              }
            ]}
            loadingText="Loading statistics"
            empty={
              <Box textAlign="center" color="inherit">
                <b>No statistics available</b>
                <Box padding={{ bottom: "s" }} variant="p" color="inherit">
                  There are no statistics to display.
                </Box>
              </Box>
            }
          />
        )}
      </SpaceBetween>
    </Container>
  );
};

export default Stats;
